// Global
import React from 'react';

// Local
import styles from '../RecipeFAQ/RecipeFAQ.module.scss';
import { KitchenTip, RecipeResponse } from 'lib/services/models/content-response';
import EnhancedRichText from 'components/helpers/Atoms/EnhancedRichText/EnhancedRichText';

import { Accordion } from 'components/helpers/Accordion/Accordion';
import useDictionary from 'lib/hooks/useDictionary';
import RecipeTipShot from '../../RecipeTipShot/RecipeTipShot';
import { buildFaqJsonLd } from 'lib/seo/seoComponentsSchema';

export interface RecipeFAQProps {
  recipe?: RecipeResponse;
  faqContent?: KitchenTip[];

  faqSettings?: {
    hideRecipeFAQ?: boolean;
  };
}

export function RecipeFAQ(props: RecipeFAQProps) {
  const { faqContent, faqSettings } = props;
  const { getDictionaryValue } = useDictionary();
  const hideRecipeFAQ = faqSettings?.hideRecipeFAQ;

  // Early return if RecipeFAQ is completely hidden
  if (hideRecipeFAQ || !faqContent || faqContent.length === 0) {
    return <></>;
  }
  // Transform KitchenTip[] to AccordionItemData[]
  const accordionItems =
    faqContent?.map((tip, index) => ({
      uid: tip.Title?.toString() || index.toString(),
      heading: tip.Title,
      content: (
        <div>
          <EnhancedRichText value={tip.Description} />
          <RecipeTipShot tipShot={tip.TipShots?.[0]} />
        </div>
      ),
    })) || [];

  const qaPairs = (faqContent || [])
    .map((tip) => ({
      question: tip?.Title?.toString().trim() || '',
      answer: tip?.Description?.toString().trim() || '',
    }))
    .filter((x) => x.question.length > 0 && x.answer.length > 0);

  const pageName = (
    props.recipe?.PageTitle ||
    props.recipe?.Title ||
    getDictionaryValue('Components.Recipe.RecipeFAQ.FAQHeader') ||
    'FAQ'
  )
    .toString()
    .trim();
  const faqJsonLd = buildFaqJsonLd(qaPairs, pageName);
  return (
    <div className={styles.recipeFAQWrapper}>
      <h2>{getDictionaryValue('Components.Recipe.RecipeFAQ.FAQHeader')}</h2>
      {faqJsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
        />
      )}
      <Accordion accordionItems={accordionItems} />
    </div>
  );
}
